import { Button, withStyles } from '@material-ui/core';
import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { isUserOrgAdmin } from '../../Common/Utils/userPermissionsUtils';
import { push } from 'react-router-redux';
import { initSubscriptionModal, openSubscriptionModal } from '../../../../actions/upgradeSubscriptionActions';
import { differenceInDays, isBefore, isValid } from 'date-fns';


const styles = theme => ({
    container: {
        padding: '4px 12px',
        marginLeft: 20,
        height: 24,
        borderRadius: 6,
        // backgroundColor: `${theme.customColors.accent} !important`,
        backgroundColor: `#6366F1 !important`,
        "textTransform": "none",
    },
    icon: {
        marginRight: 8,
    },
    text: {
        // marginRight: 8,
        "fontFamily": "Rubik",
        "fontSize": "12px",
        "fontWeight": "500",
        "fontStretch": "normal",
        "fontStyle": "normal",
        "lineHeight": "16px",
        "textAlign": "center",
        "color": "#ffffff"
    }
});

const UpgradeIcon = (props) => (
    <svg className={props.className} width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.386159 4.40209C0.146201 4.63062 0.136938 5.0104 0.36547 5.25036C0.594001 5.49032 0.973787 5.49958 1.21375 5.27105L4.99995 1.66514L8.78616 5.27105C9.02612 5.49958 9.4059 5.49032 9.63443 5.25036C9.86297 5.0104 9.8537 4.63062 9.61375 4.40208L4.99995 0.00799561L0.386159 4.40209ZM0.386168 8.76552C0.14621 8.99405 0.136947 9.37384 0.365478 9.6138C0.59401 9.85375 0.973796 9.86302 1.21375 9.63449L4.99996 6.02857L8.78617 9.63448C9.02613 9.86302 9.40591 9.85375 9.63444 9.6138C9.86298 9.37384 9.85371 8.99405 9.61376 8.76552L4.99996 4.37143L0.386168 8.76552Z" fill="white" fill-opacity="0.9"/>
    </svg>
)

class UpgradeButtonNew extends PureComponent {

    upgrade = () => {
        const trialDays = this.difDays()

        const info = { reason: 'trial-days', mode: 'existed', allowClose: true, additionalData: {trialDays} }
        this.props.dispatch(initSubscriptionModal(info))
        this.props.dispatch(openSubscriptionModal())
    }

    isSubscriptionDaysRange = () => {
        const { subscription } = this.props;
        if(!subscription?.subscriptionStart || !subscription?.subscriptionValidUntil) return false
        const d1 = new Date(subscription.subscriptionStart)
        const d2 = new Date(subscription.subscriptionValidUntil)
        if(!isValid(d1) || !isValid(d2)) return false
        if(!isBefore(d1, d2)) return false
        return true
    }

    difDays = () => {
        const d1 = new Date(this.props.subscription.subscriptionStart)
        const d2 = new Date(this.props.subscription.subscriptionValidUntil)
        const dif = differenceInDays(d2, d1)

        if(dif <= 0) return 0
        return dif
    }

    render() {
        const { classes, profileData, subscription, t } = this.props;

        const isUserAdmin = isUserOrgAdmin(profileData)
        const isSubscriptionCond = subscription.subscriptionState === 3 || subscription.subscriptionState === 0 || subscription.subscriptionType === 0
        const validDays = this.isSubscriptionDaysRange()
        if(!isUserAdmin || !isSubscriptionCond || !validDays) return null
         
        return (
                <Button onClick={this.upgrade}
                    classes={{
                        root: classes.container,
                    }}>
                    <UpgradeIcon className={classes.icon} />
                    <span className={classes.text} >{t('Upgrade')}</span>
    
                </Button>
        )
    }
}

const mapStateToProps = (state) => ({
    subscription: state.globalData.currentSubscription,
    profileData: state.userData.profileData
})

const mapDispatchToProps = dispatch => {
    return {
        dispatch: dispatch,
        goTo: path => { dispatch(push(path)) }
    }
}

export default compose(withStyles(styles, { withTheme: true }),
    withTranslation('billing'),
    connect(mapStateToProps, mapDispatchToProps))(UpgradeButtonNew);